import ServicesGrid from "@/components/site/ServicesGrid";
import ShiftModels from "@/components/site/ShiftModels";
import PageHeader from "@/components/site/PageHeader";
import { IMAGES } from "@/lib/brand";

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      <PageHeader
        eyebrow="Our Services"
        title="End-to-end manpower contracting & workforce supply"
        description="Factory workforce, housekeeping, industrial labor, and contract staffing — delivered with full statutory compliance."
        image={IMAGES.factoryAssembly}
      />
      <ServicesGrid showCta={false} />
      <ShiftModels />
    </div>
  );
}
